<template>
    <comHeader></comHeader>
    <div class="inner-banner">
        <section class="w3l-breadcrumb">
            <div class="container">
                <h4 class="inner-text-title font-weight-bold text-white mb-sm-3 mb-2">About Us</h4>
                <ul class="breadcrumbs-custom-path">
                    <li><a href="/">Home</a></li>
                    <li class="active"><span class="fa fa-chevron-right mx-2" aria-hidden="true"></span>Products</li>
                </ul>
            </div>
        </section>
    </div>

    <section class="w3l-about-2 py-5">
        <div class="container py-md-5 py-4">
                <!-- col-lg-6 about-2-secs-left pr-lg-5 -->
                <div class="about-2-secs-left pr-lg-5">
                    <div class="product-page">
                        <!-- 上边内容区域，左右布局 -->
                        <div class="top-section">
                            <div class="top-left">
                                <!-- 这里替换成实际的图片地址，可根据需求调整为动态数据 -->
                                <!-- <div class="pet-tag-img" v-for="(item, index) in products" :key="index">
                                    <img src="@/assets/images/intro1.jpg" alt="Pet Tag Front" class="pet-tag-img" />
                                    <img src="@/assets/images/intro2.jpg" alt="Pet Tag Back" class="pet-tag-img" />
                                </div> -->
                                <div  v-for="(item, index) in products" :key="index">
                                     <img :src="'/static/images/'+item.picDir" alt="Pet Tag Front" class="pet-tag-img" />
                                </div>
                                
                            </div>
                            <div class="top-right">
                                <div class="content-div">
                                    <h2 class="line-hight">QR code recognition:</h2>
                                    <p style="font-size: 18px;color:#000">no need for app, scanning the code will show the pet information page, convenient
                                        for
                                        rescuers to contact the owner.</p>
                                </div>
                                <div class="content-div">
                                    <h2 class="line-hight">Lightweight material choice:</h2>
                                    <p style="font-size: 18px;color:#000">reduce the burden on the neck, suitable for all kinds of dogs.</p>
                                </div>
                                <div class="content-div">
                                    <h2  class="line-hight">Waterproof and durable:</h2>
                                    <p style="font-size: 18px;color:#000">not affected by weather, suitable for dogs with frequent outdoor activities.</p>
                                </div>
                                <div class="content-div">
                                    <h2 class="line-hight">Suitable for all kinds of collars:</h2>
                                    <p style="font-size: 18px;color:#000">can be easily attached to any standard pet collar or carrier.</p>
                                </div>
                                <div class="content-div">
                                    <h2  class="line-hight">Package Includes:</h2>
                                    <p style="font-size: 18px;color:#000">ID Tag × 1 Lanyard × 1</p>
                                </div>
                            </div>
                        </div>
                        <!-- 下边内容区域，展示大图 -->
                        <div class="bottom-section">
                            <!-- 这里替换成实际的图片地址，可根据需求调整为动态数据 -->
                             <img :src="'/static/images/'+bigpic.picDir" alt="Registration Process"
                                class="big-img" />
                        </div>
                    </div>
            </div>
        </div>
    </section>
</template>

<script>
import comHeader from '@/components/comHeader.vue';

export default {
    name: 'appProduct',
    components: {
        comHeader
    }
}
</script>

<script setup>
import { api } from '@/assets/js/requests';
import { onMounted, ref } from 'vue';
    const products = ref([]);
    const bigpic = ref('');
    onMounted (async () => {    
        const expireTime = localStorage.getItem('productCacheExpire');
        if (expireTime && Date.now() > parseInt(expireTime)) {
            localStorage.removeItem('productPics');
            localStorage.removeItem('productCacheExpire');
            localStorage.removeItem('bigPics');
        }
        getProductPics().then(res => {
            products.value = res;
        });
        getBigProductPics().then(res => {
            if(res && res.length > 0){
                console.log(res)
                bigpic.value = res[0];
            }
        });

})
    const getProductPics = () => {
        return new Promise((resolve, reject) => {
            try {
                const cachedPics = localStorage.getItem('productPics');
                if (cachedPics) {
                    resolve(JSON.parse(cachedPics));
                    return;
                }
                api.system.getSystemPics('3').then(res => {   
                    if (res.data && res.data.data.length > 0) {
                        localStorage.setItem('productPics', JSON.stringify(res.data.data));
                    }
                    resolve(res.data.data);
                })
            }catch(err){
                reject(err);
            }
        })
    };

    const getBigProductPics = () => {
        return new Promise((resolve, reject) => {
            try {
                const cachedPics = localStorage.getItem('bigPics');
                if (cachedPics) {
                    resolve(JSON.parse(cachedPics));
                    return;
                }
                api.system.getSystemPics('4').then(res => {   
                    if (res.data && res.data.data.length > 0) {
                        localStorage.setItem('bigPics', JSON.stringify(res.data.data));
                    }
                    resolve(res.data.data);
                })
            }catch(err){
                reject(err);
            }
        })
    };
</script>

<style lang="css">
.product-page {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.top-section {
    display: flex;
    flex-wrap: wrap;
    /* 屏幕变窄时自动换行，保证适配 */
    justify-content: space-between;
    align-items: flex-start;
    padding: 20px;
}

.content-div{
    padding:10px 0;
}

.line-hight{
    line-height: 25px;
    padding-bottom: 10px;
    font-weight: bolder;

}

.top-left {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    justify-content: center;
}

.pet-tag-img {
    width: 400px;
    /* 可根据实际需求调整图片宽度 */
    height: auto;
    
}

.top-right {
    flex: 1;
    margin-left: 30px;
    line-height: 1.6;
}

.bottom-section {
    width: 100%;
    padding: 20px;
}

.big-img {
    width: 100%;
    height: auto;
    display: block;
}

/* 响应式适配，屏幕较窄时调整布局 */
@media (max-width: 768px) {
    .top-section {
        flex-direction: column;
    }

    .top-right {
        margin-left: 0;
        margin-top: 20px;
    }
}
</style>
